import { render, staticRenderFns } from "./ModalCopyMdtDisease.vue?vue&type=template&id=4e9004c3&scoped=true"
import script from "./ModalCopyMdtDisease.vue?vue&type=script&lang=js"
export * from "./ModalCopyMdtDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9004c3",
  null
  
)

export default component.exports